import { FormControl, InputLabel, Select, SelectProps } from '@mui/material';
import { FC } from 'react';

type CommonPermittedMUISelectProps = Pick<
  SelectProps,
  'id' | 'className' | 'value' | 'variant' | 'onChange' | 'aria-label' | 'error'
>;

type LabelProps =
  | {
      labelText: string;
      labelId: string;
    }
  | {
      labelText?: never;
      labelId?: string;
    };

type HelixSelectProps = CommonPermittedMUISelectProps & LabelProps;

const HelixSelect: FC<HelixSelectProps> & Pick<typeof Select, 'muiName'> = (props) => {
  const { children, className, variant, labelText, labelId, ...rest } = props;

  return (
    <FormControl className={className} variant={variant}>
      {labelText && <InputLabel id={labelId}>{labelText}</InputLabel>}
      <Select {...rest} labelId={labelId}>
        {children}
      </Select>
    </FormControl>
  );
};
HelixSelect.muiName = Select.muiName;

export { HelixSelect as default, HelixSelect };
export type { HelixSelectProps };
